import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductEvaluationTaskService } from '../../../services/product-evaluation-task.service';

@Component({
  selector: 'app-product-evaluation-task-logs',
  standalone: false,
  templateUrl: './product-evaluation-task-logs.component.html',
})
export class ProductEvaluationTaskLogsComponent implements OnInit {
  dataLoading = false
  @Input() recordId!: number;
  @Output() close = new EventEmitter<boolean>();
  recordsData: any[] = [];

  constructor(
    private service: ProductEvaluationTaskService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true
    this.service.getTaskLogs(this.recordId).subscribe((data) => {
      this.recordsData = data as any[];
      this.dataLoading = false
    }, (error: any) => {

    })
  }
}
